module.exports = {
    fields: {
        email: "邮箱",
        password: "密码",
        userName: '用户名',
        code: '验证码',
        confirm: '确认密码',

    },
    validation: {
        "required": '{_field_}不能为空',
        "min": '{_field_}不能小于6位',
        "userName": '{_field_}为4到16位(字母，数字，下划线，减号)',
        "confirmed": '两次密码不一致',
        "code": '{_field_}为6位数字',
        "email":'{_field_} 格式错误',
    }
}